<template>
  <div class="container">
    <div v-if="loading">
      <div id="loader">
        <font-awesome-icon icon="spinner" spin />
      </div>
    </div>

    <h4 class="cardD">Generación de documentos</h4>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-dialog" hide-footer id="modal-confirm-dialog">
      <h4 class="text-center">¿Seguro que quiere eliminar el documento?</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-dialog')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="deleteDocumento">OK</b-button>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="documento-modal" title="" hide-footer id="modalC" size="xl">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(postDocumento)">
          <ModalDocumentos
            :currentDocumento="currentDocumento"
            :options="optionsDocumentosProyectoComputed"
            :accepted-file-types="'application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document'"
            @submit.prevent
          />
        </form>
      </ValidationObserver>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="documento-modal-preview-img" title="" hide-footer id="modaldi" size="xl">
      <ModalPreviewImg :currentDocumento="currentDocumento" />
    </b-modal>
    <b-modal no-close-on-backdrop centered ref="documento-modal-preview-pdf" title="" hide-footer id="modaldf" size="xl">
      <ModalPreviewPDF :currentDocumento="currentDocumento" />
    </b-modal>
    <b-modal no-close-on-backdrop centered ref="documento-modal-preview-docx" title="" hide-footer id="modaldd" size="xl">
      <ModalPreviewDocx :currentDocumento="currentDocumento" />
    </b-modal>

    <h4 class="cardD mt-1">Proyecto de constitutiva</h4>

    <div class="row">
      <div class="col-6">
        <b-button
          block
          variant="primary"
          class="btn-fill"
          size="m"
          @click="generaProyecto()"
          :disabled="false && !listoGenerarProyecto"
        >
          Generar Carta instrucción
        </b-button>
      </div>
      <div class="col-6">
        <b-button
          block
          variant="info"
          class="btn-fill"
          size="m"
          @click="descargaProyecto()"
          :disabled="constitutiva.proyecto_generado === null"
        >
          <i class="fa fa-download"></i>
          Descargar Carta instrucción
        </b-button>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-md-4">
        <b-button v-if="constitutiva.documentos_proyecto.length >= 2" class="btn-fill" variant="success" @click="addDocumento">
          + Cargar Proyecto
        </b-button>
      </div>
    </div>

    <b-table hover :fields="fieldsProyecto" :items="constitutiva.documentos_proyecto">
      <template #cell(acciones)="{ item, index }">
        <b-button variant="warning" size="sm" v-b-tooltip.hover title="Editar" @click="editDocumento(index)" class="editBtn">
          <b-icon-pencil />
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          v-b-tooltip.hover
          title="Descargar"
          @click="descargaDocumento(item)"
          class="editBtn"
        >
          <b-icon-download />
        </b-button>
        <b-button
          variant="danger"
          size="sm"
          v-b-tooltip.hover
          title="Editar"
          @click="predeleteDocumento(index)"
          class="editBtn"
          :disabled="constitutiva.disabledDocumentos"
        >
          <b-icon-trash />
        </b-button>
        <b-button
          v-if="item.documento"
          variant="primary"
          size="sm"
          v-b-tooltip.hover
          title="Vista previa"
          @click="previewDocumento(item)"
          class="editBtn"
          :hidden="item.disabled"
        >
          <b-icon-eye />
        </b-button>
      </template>
    </b-table>

    <div class="mt-4">
      <div class="">
        <b-button
          type="submit"
          class="btn-fill orange-btn bottom2 float-right"
          size="m"
          :disabled="constitutiva.disabledDocumentos"
        >
          Guardar
        </b-button>
      </div>
    </div>

    <h4 class="cardD mt-1 bottom3" v-if="false">Enviar Carta instrucción a firma digital</h4>
    <!-- <label class="leyenda blue-text-important mt-1" v-if="!listoEnvioProyecto">
      Debe estar cargado el proyecto en Word y en PDF para poder enviarlo a los accionistas para su firma digital.
    </label> -->
    <div class="mt-3" v-if="listoEnvioProyecto">
      <div>
        <b-button
          block
          variant="success"
          class="btn-fill"
          size="m"
          :disabled="disabledSendProyectoFad"
          @click="enviarProyectoFad()"
        >
          Enviar Carta instrucción a firma digital
        </b-button>
        <label class="leyenda blue-text-important mt-1" v-if="disabledSendKycsFad">
          Si la opción está deshabilitada, es porque ya se enviaron a Firma
        </label>
        <b-button block variant="secondary" class="btn-fill" size="m" :disabled="false" @click="checkStatusProyectoFad">
          Consultar estatus FAD
        </b-button>
      </div>
    </div>

    <h4 class="cardD bottom3">Generar KYCs</h4>
    <b-button
      block
      variant="success"
      class="btn-fill mb-3"
      size="m"
      :disabled="constitutiva.disbaledGeneraDocs"
      @click="generaKycs()"
    >
      Generar
    </b-button>
    <b-table hover :fields="fields" :items="constitutiva.documentos_kycs">
      <template #cell(acciones)="{ item }">
        <b-button
          variant="primary"
          size="sm"
          v-b-tooltip.hover
          title="Vista previa"
          @click="previewDocumento(item)"
          class="editBtn"
          :disabled="constitutiva.disbaledGeneraDocs"
        >
          <b-icon-eye />
        </b-button>
      </template>
    </b-table>

    <h4 class="cardD bottom3">Enviar KYCs a firma digital</h4>
    <label class="leyenda blue-text-important mt-1" v-if="true || !listoGenerar">
      Todos los formularios deberán estar validados y se deberá tener cargado el proyecto en Word y en PDF para poder enviarlos a
      los accionistas para su firma digital.
    </label>

    <div class="mt-3">
      <div v-if="listoGenerar">
        <b-button block variant="success" class="btn-fill" size="m" :disabled="disabledSendKycsFad" @click="enviarKycsFad()">
          Enviar KYCs a firma digital
        </b-button>
        <label class="leyenda blue-text-important mt-1" v-if="disabledSendKycsFad">
          Si la opción está deshabilitada, es porque ya se enviaron a Firma
        </label>
        <b-button block variant="secondary" class="btn-fill" size="m" :disabled="false" @click="checkStatusKycFad">
          Consultar estatus FAD
        </b-button>
      </div>
      <div v-else>
        <div class="bg-danger text-light" id="aviso">Contacte a cliente para obtener más datos</div>
      </div>
    </div>

    <div hidden v-if="toGenerateKycs">
      <div v-for="item in comparecientesToGenerateKycs_" :key="item.id" :ref="'kyc-' + item.id">
        <KycTemplate
          :id="item.id"
          :currentCompareciente="item"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ModalDocumentos from "@/views/clients/procesos/constitucion/entregadocumentos/ModalDocumentos.vue";
import ModalPreviewImg from "@/views/clients/procesos/constitucion/entregadocumentos/ModalPreviewImg.vue";
import ModalPreviewPDF from "@/views/clients/procesos/constitucion/entregadocumentos/ModalPreviewPDF.vue";
import ModalPreviewDocx from "@/views/clients/procesos/constitucion/entregadocumentos/ModalPreviewDocx.vue";
import KycTemplate from "@/views/staff/tasks/validaciones/constitucionsociedades/KycTemplate.vue";

import {
  AccionistasApi,
  CatDocumentosApi,
  DocumentosXServiciosApi,
  ConstitucionSociedadesApi,
  FuncionesApi,
  DocumentosApi,
  ComparecientesApi,
} from "@/api";
import config from "@/config";

export default {
  name: "TabGeneraDocumento",

  components: {
    ModalDocumentos,
    KycTemplate,
    ModalPreviewImg,
    ModalPreviewPDF,
    ModalPreviewDocx,
  },

  props: {
    constitutiva: { type: Object },
  },

  created() {
    this.checkProyectoGenera();
    this.checkValidaciones();
    this.colocaEstatusKYCs();
  },

  data() {
    return {
      loading: false,
      toGenerateKycs: false,

      listoGenerarProyecto: false,
      listoGenerar: false,
      listoEnvioProyecto: false,

      toEditCurrentDocumento: false,
      currentDocumento: null,
      currentDocumentoIndex: null, // no confundir con el id del documento

      disabledSendKycsFad: false,
      disabledSendProyectoFad: false,

      comparecientesToGenerateKycs_: [],

      style_pdf:
        "<style>.maps{text-align:center;vertical-align:middle}.new-page{break-before:page}.logo{width:auto;height:100px;float:right}.tabla{width:100%;font-size:15px;font-family:Arial,Helvetica,sans-serif;border-collapse:separate;border-spacing:0 1em}.section{background-color:#4bacc6;color:#fff;text-align:center;height:40px;font-weight:bolder}.section-empty{text-align:center;font-weight:bolder;font-size:18px}.firstline{border:5px solid #fff}.title{font-size:12px;text-align:left;width:20%;font-weight:700}.select{text-align:left;width:5%}.circle{border-radius:100%;height:15px;width:15px;border:2px solid #4bacc6;margin-bottom:0}.filledcircle{border-radius:100%;height:15px;width:15px;border:2px solid #4bacc6;background-color:#4bacc6;margin-bottom:0}.verifycheck{border:2px solid #4bacc6;background-color:#e7eef5;text-align:center}.right-title{font-size:12px;text-align:right;font-weight:700}.user{text-align:left;font-size:12px;font-weight:lighter;border-bottom:solid 1px #000;background-color:#e7eef5}.leyenda{font-size:9px}</style>",

      stgAccessKey: config.CD_STG_ACCESS_KEY,
    };
  },

  computed: {
    fields() {
      return [
        // { key: "index", label: "", class: "text-center" },
        { key: "nombreFile", label: "Nombre", class: "text-center" },
        { key: "tipo", label: "Tipo", class: "text-center" },
        { key: "estatus", label: "Estatus", class: "text-center" },
        { key: "acciones", label: "Acciones", class: "text-center" },
      ];
    },
    fieldsProyecto() {
      return [
        // { key: "index", label: "", class: "text-center" },
        { key: "nombreFile", label: "Nombre", class: "text-center" },
        { key: "tipo", label: "Tipo", class: "text-center" },
        { key: "estatus", label: "Estatus", class: "text-center" },
        { key: "acciones", label: "Acciones", class: "text-center" },
      ];
    },
    optionsDocumentosProyectoComputed() {
      const arr = [];

      if (this.toEditCurrentDocumento) {
        if (this.currentDocumento.cat_documentos_id == 24) {
          arr.push({ text: "Proyecto constitutiva PDF", value: "Proyecto constitutiva PDF" });
        }

        if (this.currentDocumento.cat_documentos_id == 25) {
          arr.push({ text: "Proyecto constitutiva Word", value: "Proyecto constitutiva Word" });
        }
      } else {
        if (!this.constitutiva.documentos_proyecto.some((d) => d.cat_documentos_id == 24)) {
          arr.push({ text: "Proyecto constitutiva PDF", value: "Proyecto constitutiva PDF" });
        }
        if (!this.constitutiva.documentos_proyecto.some((d) => d.cat_documentos_id == 25)) {
          arr.push({ text: "Proyecto constitutiva Word", value: "Proyecto constitutiva Word" });
        }
      }

      return arr;
    },
  },

  methods: {
    checkProyectoGenera() {
      const c = this.constitutiva;
      const tieneAutorizada = c.denominaciones_sociales.some((o) => o.autorizada);
      const validos = [
        c.validoCapital,
        c.validoCapitulos,
        c.validoComplementa,
        c.validoCotizacion,
        c.validoEntidad,
        c.validoOrganos,
        c.validoRepresentantes,
      ];

      if (tieneAutorizada && validos.every(Boolean)) {
        this.listoGenerarProyecto = true;
      }
    },

    checkValidaciones() {
      //si ya están en uno valido todos los anteriores - boton generear docs y enviar a firam
      //ademas de que ya hayan 2 docs en consitutivas.documentos_proyecto
      let count = 0;

      for (let i = 0; i < this.constitutiva.formularios.length; i++) {
        if (
          this.constitutiva.formularios[i].formulario != "EntregaDocumentos" &&
          this.constitutiva.formularios[i].formulario != "CitaFirma" &&
          this.constitutiva.formularios[i].formulario != "DocListo" &&
          this.constitutiva.formularios[i].formulario != "DenominacionSocial" &&
          this.constitutiva.formularios[i].formulario != "Expediente" &&
          this.constitutiva.formularios[i].formulario != "FirmaDigital"
        ) {
          if (this.constitutiva.formularios[i].valido != 1) {
            count++;
          }
        }
      }

      if (this.constitutiva.documentos_proyecto.length != 2) {
        count++;
      }

      if (count == 0) {
        this.listoGenerar = true;
      }

      //check validación de envío kycs a fad
      //buscar en constitutiva.fad_responses si algun objeto tiene el campo comparecientes_id != null
      // if (this.constitutiva.fad_procesos.length > 0) {
      //   for (let r = 0; r < this.constitutiva.fad_procesos.length; r++) {
      //     if (this.constitutiva.fad_procesos[r].comparecientes_id) {
      //       this.disabledSendKycsFad = true;
      //     }
      //   }
      // }

      //check validación de envío proyecto a fad
      if (this.constitutiva.documentos_proyecto.length == 2) {
        this.listoEnvioProyecto = true;
      }
    },

    async colocaEstatusKYCs() {
      for (let i = 0; i < this.constitutiva.documentos_kycs.length; i++) {
        const nombreFile = this.constitutiva.documentos_kycs[i].nombreFile;

        if (!nombreFile) {
          continue;
        }

        //de nombreFile obtiene la string que está entre el guion bajo y el punto
        const nombre_completo = nombreFile.substring(nombreFile.lastIndexOf("_") + 1, nombreFile.lastIndexOf("."));
        const index = this.findIndexAccio(nombre_completo);

        if (index === -1) {
          continue;
        }

        const compar_id = this.constitutiva.accionistas[index].id;
        const indexFad = this.constitutiva.fad_procesos.findIndex((o) => o.comparecientes_id === compar_id);

        if (indexFad === -1) {
          this.constitutiva.documentos_kycs[i].cat_fad_responses_id = null;
          continue;
        }

        const estatus_id = this.constitutiva.fad_procesos[indexFad].cat_fad_responses_id;
        this.constitutiva.documentos_kycs[i].cat_fad_responses_id = estatus_id;

        const estatus_name = await FuncionesApi.getCatFadResponseRespuesta(estatus_id);
        this.constitutiva.documentos_kycs[i].estatus = estatus_name;

        this.constitutiva.documentos_kycs.splice(i, 1, { ...this.constitutiva.documentos_kycs[i] });
      }

      //PONER ESTATUS EN PROYECYTO CONSTITUTIVA TAMBIEN
      const indexFad_proyecto = this.constitutiva.fad_procesos.findIndex((o) => o.comparecientes_id === 0);
      if (indexFad_proyecto === -1) {
        return;
      }

      const index_doc_proyecto = this.constitutiva.documentos_proyecto.findIndex((o) => o.tipo === "Proyecto constitutiva PDF");
      if (index_doc_proyecto === -1) {
        return;
      }

      const indexEstatusFadProyecto = this.constitutiva.fad_procesos[indexFad_proyecto].cat_fad_responses_id;
      const estatus_name = await FuncionesApi.getCatFadResponseRespuesta(indexEstatusFadProyecto);
      this.constitutiva.documentos_proyecto[index_doc_proyecto].estatus = estatus_name;

      this.constitutiva.documentos_proyecto.splice(index_doc_proyecto, 1, {
        ...this.constitutiva.documentos_proyecto[index_doc_proyecto],
      });
    },

    findIndexAccio(nombre_completo) {
      const nombre_completo_nospace = nombre_completo.replace(/\s/g, "");
      return this.constitutiva.accionistas.findIndex((a) => a.nombreCompleto.replace(/\s/g, "") === nombre_completo_nospace);
    },

    async generaProyecto() {
      try {
        this.loading = true;

        const url_proyecto = await FuncionesApi.generaProyecto({
          cat_servicios_id: 1,
          proceso_id: this.constitutiva.id,
          tipo_documento: this.constitutiva.tipo_societario,
        });

        this.constitutiva.proyecto_generado = { documento: url_proyecto };

        this.$toast.success("Proyecto generado, puede descargarlo", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } catch (error) {
        console.log(error);

        this.$toast.error("Sucedió un error, intente más tarde.", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } finally {
        this.loading = false;
      }
    },

    descargaProyecto() {
      const link = document.createElement("a");
      link.href = this.constitutiva.proyecto_generado.documento + this.stgAccessKey;
      // link.setAttribute("download"); //or any other extension  , "file.png"
      document.body.appendChild(link);
      link.click();
    },

    descargaDocumento(item) {
      const link = document.createElement("a");
      link.href = item.documento + this.stgAccessKey;
      // link.setAttribute("download"); //or any other extension  , "file.png"
      document.body.appendChild(link);
      link.click();
    },

    previewDocumento(item) {
      this.currentDocumento = item;
      const tipoDocumento = item.nombreFile.split(".").pop().toLowerCase();

      const modalMap = {
        pdf: "documento-modal-preview-pdf",
        docx: "documento-modal-preview-docx",
      };

      const imageTypes = new Set(["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg", "tiff", "avif"]);

      if (modalMap[tipoDocumento]) {
        this.$refs[modalMap[tipoDocumento]].show();
      } else if (imageTypes.has(tipoDocumento)) {
        this.$refs["documento-modal-preview-img"].show();
      }
    },

    async generaKycs() {
      try {
        this.loading = true;
        const comparecientes_d = [];

        await this.prepareComparecientesToGenerateKyc();
        this.toGenerateKycs = true;
        await this.$nextTick();

        for (const compareciente of this.comparecientesToGenerateKycs_) {
          const el = this.$refs["kyc-" + compareciente.id];
          if (!el || !el[0]) {
            // TODO handle this
            continue;
          }

          const html = el[0].innerHTML;
          const html_total =
            '<!DOCTYPE html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1.0">' +
            `${this.style_pdf}</head><body>${html}</body></html>`.replace(/data-v-[a-z0-9]*=""/g, "");
          // console.log(html_total);
          const buffer = Buffer.from(html_total);
          const buffer_str = buffer.toString("base64");

          comparecientes_d.push({
            comparecientes_id: compareciente.id,
            html: buffer_str,
          });
        }

        const documentos_kycs = await FuncionesApi.generaKyc({
          proceso_id: this.constitutiva.id,
          cat_servicios_id: 1,
          comparecientes: comparecientes_d,
        });

        this.toGenerateKycs = false;

        documentos_kycs.forEach((d) => {
          d.nombreFile = d.documento?.split("/").pop() || null;
          d.tipo = "KYC";
        });

        this.constitutiva.documentos_kycs = documentos_kycs;
        this.disabledSendKycsFad = false;
        this.listoGenerar = true;

        this.$toast.success("KYCs generados", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } catch (error) {
        console.log(error);
        this.$toast.error("Sucedió un error, intente más tarde", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
        this.toGenerateKycs = false;
      } finally {
        this.loading = false;
      }
    },

    async enviarKycsFad() {
      try {
        this.loading = true;

        const result = await FuncionesApi.sendKycsFad({
          proceso_id: this.constitutiva.id,
          cat_servicios_id: 1,
        });

        this.$toast.success("KYCs enviados a firma", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });

        //deshabilita btn para no hacer 2 veces la request
        this.disabledSendKycsFad = true;

        const { fad_procesos } = await ConstitucionSociedadesApi.detail(this.constitutiva.id);

        this.constitutiva.fad_procesos = fad_procesos;

        this.constitutiva.documentos_kycs.forEach((element) => {
          element.estatus = "STARTED";
        });
      } catch (error) {
        console.log(error);
        this.$toast.error("Sucedió un error, intente más tarde", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } finally {
        this.loading = false;
      }
    },

    async enviarProyectoFad() {
      try {
        this.loading = true;

        const result = await FuncionesApi.sendProyectoConstitutivaFad({
          proceso_id: this.constitutiva.id,
          cat_servicios_id: 1,
        });

        this.$toast.success("Proyecto enviado a firma digital", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });

        //deshabilita btn para no hacer 2 veces la request
        this.disabledSendProyectoFad = true;

        //FALTA PONER EL ESTATUS DE LA FIRMA DEL PROYE
        const doc = this.constitutiva.documentos_proyecto.find((o) => o.tipo === "Proyecto constitutiva PDF");

        if (doc) {
          doc.estatus = "STARTED";
        }
      } catch (error) {
        console.log(error);
        this.$toast.error("Sucedió un error, intente más tarde", {
          timeout: 4000, //false,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } finally {
        this.loading = false;
      }
    },

    addDocumento() {
      this.currentDocumentoIndex = null;
      this.currentDocumento = {};
      this.$refs["documento-modal"].show();
    },

    async postDocumento() {
      await this.addFile();

      this.$refs["documento-modal"].hide();

      this.currentDocumento.estatus = "";

      if (this.currentDocumento.tipo == "Proyecto constitutiva PDF") {
        this.currentDocumento.cat_documentos_id = 24;
      } else if (this.currentDocumento.tipo == "Proyecto constitutiva Word") {
        this.currentDocumento.cat_documentos_id = 25;
      }

      const a = structuredClone(this.currentDocumento);

      if (!this.currentDocumentoIndex) {
        // this.currentDocumento.index = this.constitutiva.documentos_proyecto.length + 1;
        this.constitutiva.documentos_proyecto.push(a);
      } else if (this.currentDocumento.index) {
        // const index = this.constitutiva.documentos_proyecto.findIndex((o) => o.index === this.currentDocumento.index);
        this.constitutiva.documentos_proyecto.splice(currentDocumentoIndex, 1, a);
      }

      if (a.id) {
        const result = await DocumentosApi.edit(a.id, a);
      } else {
      }

      this.currentDocumentoIndex = null;
      this.toEditCurrentDocumento = false;
    },

    async addFile() {
      try {
        this.loading = true;

        const file = this.currentDocumento.file;

        this.currentDocumento.nombreFile = file.name;
        this.currentDocumento.nombre = file.name;

        const formData = new FormData();
        formData.append("file", file);
        const value = await FuncionesApi.file(this.constitutiva.id, "documentosConstituciones", formData);

        this.currentDocumento.documento = value;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    editDocumento(index) {
      this.toEditCurrentDocumento = true;
      this.currentDocumentoIndex = index;
      this.currentDocumento = this.constitutiva.documentos_proyecto[index];
      this.$refs["documento-modal"].show();
    },

    predeleteDocumento(index) {
      this.currentDocumentoIndex = index;
      this.$refs["modal-confirm-dialog"].show();
    },

    async deleteDocumento() {
      const documento = this.constitutiva.documentos_proyecto[this.currentDocumentoIndex];
      const pathParts = documento.documento.split("/");
      const documentoPath = pathParts.slice(-3).join("/");

      const result = await this.deleteFile(documentoPath);

      this.constitutiva.documentos_proyecto.splice(this.currentDocumentoIndex, 1);

      await DocumentosApi.delete(documento.id);

      this.currentDocumentoIndex = null;

      this.$refs["modal-confirm-dialog"].hide();
    },

    async deleteFile(path) {
      try {
        this.loading = true;

        await FuncionesApi.deleteFile("documentosConstituciones", {
          path: path,
        });

        this.$toast.success("Archivo eliminado del servidor.", {
          timeout: 2000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });

        return true;
      } catch (error) {
        console.log(error);
        this.$toast.error("Ocurrió un error al tratar de borrar el archivo del servidor.", {
          timeout: 2000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
        return false;
      } finally {
        this.loading = false;
      }
    },

    async checkStatusProyectoFad() {
      try {
        this.loading = true;

        const response = await FuncionesApi.checkFadProyectoConstitutivaEstatus({
          cat_servicios_id: 1,
          proceso_id: this.constitutiva.id,
        });

        if (response.areDocumentosFadFirmados) {
          this.$toast.success("Consulta de estatus de FAD exitosa, recargando la página.", {
            timeout: 4000,
            hideProgressBar: false,
            position: "top-right",
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            closeButton: "button",
            icon: true,
          });

          // this.$router.replace({ path: this.$route.path, query: { node: "GeneraDocumento" } });
          this.$router.push({
            name: "ValidConstitucionSociedades",
            params: { id: this.constitutiva.id },
            query: { node: "GeneraDocumento" },
          });
        }

        this.$toast.success(
          "Consulta de estatus de FAD exitosa, no ha habido cambio en el estatus del documento enviado a firmar.",
          {
            timeout: 6000,
            hideProgressBar: false,
            position: "top-right",
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            closeButton: "button",
            icon: true,
          },
        );
      } catch (error) {
        console.log(error);
        this.$toast.error("Sucedió un error, intente más tarde", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } finally {
        this.loading = false;
      }
    },

    async checkStatusKycFad() {
      try {
        this.loading = true;

        const response = await FuncionesApi.checkFadKycsEstatus({
          cat_servicios_id: 1,
          proceso_id: this.constitutiva.id,
        });

        if (response.areDocumentosFadFirmados) {
          this.$toast.success("Consulta de estatus de FAD exitosa, recargando la página.", {
            timeout: 4000,
            hideProgressBar: false,
            position: "top-right",
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            closeButton: "button",
            icon: true,
          });

          // this.$router.replace({ path: this.$route.path, query: { node: "GeneraDocumento" } });
          this.$router.push({
            name: "ValidConstitucionSociedades",
            params: { id: this.constitutiva.id },
            query: { node: "GeneraDocumento" },
          });
        }

        this.$toast.success(
          "Consulta de estatus de FAD exitosa, no ha habido cambio en el estatus de los kYCs enviados a firmar.",
          {
            timeout: 6000,
            hideProgressBar: false,
            position: "top-right",
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            closeButton: "button",
            icon: true,
          },
        );
      } catch (error) {
        console.log(error);
        this.$toast.error("Sucedió un error, intente más tarde", {
          timeout: 4000,
          hideProgressBar: false,
          position: "top-right",
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          closeButton: "button",
          icon: true,
        });
      } finally {
        this.loading = false;
      }
    },

    async prepareComparecientesToGenerateKyc() {
      const result = await ComparecientesApi.getComparecientesParaKycFromConstitutiva(this.constitutiva.id);
      this.comparecientesToGenerateKycs_ = result;
    },
  },
};
</script>

<style scoped>
#aviso {
  text-align: center;
  padding: 8px 16px;
  border-radius: 0.25rem;
}
</style>
